"use client";

import { MsalProvider } from "@azure/msal-react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ReactNode } from "react";
import { Provider } from "react-redux";

import ReactQueryProvider from "@/components/providers/ReactQueryProvider";
import { msalInstance } from "@/config/authConfig";
import { useClearCache } from "@/helper/useClearCache";
import { useStoreRef } from "@/lib/hooks/useStoreRef";

interface RootProvidersProps {
  children: ReactNode;
}

export function RootProviders({ children }: RootProvidersProps) {
  const store = useStoreRef();
  const clearCache = useClearCache();
  return (
    <Provider store={store}>
      <MsalProvider instance={msalInstance}>
        <GoogleOAuthProvider
          clientId={process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID ?? ""}
        >
          <ReactQueryProvider>{children}</ReactQueryProvider>
        </GoogleOAuthProvider>
      </MsalProvider>
    </Provider>
  );
}
